export default "__VITE_ASSET__B9cAR1Px__"